import { ChiefEditorDetailModel } from './chief-editor.detail.model';

export class PagedChiefEditorDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: Array<ChiefEditorDetailModel>;

    constructor() {
        this.items = new Array<ChiefEditorDetailModel>();
    }
}
